import { IntegrationInstallationId } from '../types';

export enum BrokenIntegrationNotifyMode {
    All = 'all',
    Specified = 'specified',
}

export enum BrokenIntegrationFilterMode {
    Include = 'include',
    Exclude = 'exclude',
}

export enum BrokenIntegrationDurationUnit {
    Minutes = 'minutes',
    Hours = 'hours',
    Days = 'days',
}

export const DEFAULT_BROKEN_INTEGRATION_DURATION_VALUE = 24;
export const DEFAULT_BROKEN_INTEGRATION_DURATION_UNIT = BrokenIntegrationDurationUnit.Hours;

export interface BrokenIntegrationNotificationSettings {
    brokenIntegrationNotifyMode?: BrokenIntegrationNotifyMode;
    brokenIntegrationFilterMode?: BrokenIntegrationFilterMode;
    brokenIntegrationInstallationIds?: IntegrationInstallationId[];
    brokenIntegrationDurationValue?: number;
    brokenIntegrationDurationUnit?: BrokenIntegrationDurationUnit;
}
